<template>
  <div class="register-result">
    <img src="../../../../static/img/icon-finish.png" class="icon">
    <div class="txt1">报名成功</div>
    <div class="txt2">恭喜，{{company}}，您已成功报名，您的报名回执已发送至展会联系人邮箱，请注意查收。</div>
    <!-- <div class="f-tac  btn">
      <Button type="primary" size="large" @click="linkTo">返回官网</Button>
    </div> -->
    <div class="btn3" @click="linkTo">点击获取销售联系方式（{{count}}秒后跳转）</div>
    <img src="../../../../static/img/qr.png">
    <div class="txt3">官网微信</div>
  </div>
</template>

<script>
export default {
  name: 'register-result',
  data () {
    return {
      company: '',
      exname: '',
      count: 3,
      timer: null,
    };
  },
  methods: {
    linkTo () {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = null;
      window.location.href = 'https://www.apichina.com.cn/#/about?changeS=true';
    },
  },
  created () {
    this.timer = setInterval(c => {
      if (this.count > 0) {
        this.count = this.count - 1;
      } else {
        this.linkTo();
      }
    }, 1000);
  },
  mounted () {
    const query = this.$route.query;
    this.company = query.company;
    this.exname = query.exname;
    console.log('query', query);
  }
}

</script>

<style lang="scss" scoped>
.register-result {
  width: 100%;
  text-align: center;
  .icon {
    display: block;
    margin: 80px auto 25px;
  }
  .txt1 {
    font-size: 24px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
  }
  .txt2 {
    font-size: 16px;
    color: #333;
    margin-bottom: 25px;
    line-height: 1.8;
    padding: 20px;
    text-align: center;
  }
  .txt3 {
    font-size: 14px;
    color: #666;
    margin-bottom: 120px;
  }
}
.btn {
  button {
    height: 48px;
    padding: 0 50px;
    background-color: #fff;
    font-size: 18px;
    border-radius: 5px;
    border: solid 1px #e5e5e5;
    margin-bottom: 80px;
    color: #333;
  }
}
.btn3 {
  cursor: pointer;
  width: 320px;
  height: 50px;
  text-align: center;
  margin: 0 auto 40px;
  line-height: 50px;
  font-size: 16px;
  border-radius: 5px;
  padding-left: 5px;
  color: #fff;
  text-align: center;
  background-image: linear-gradient(-90deg, #18c1cd 0%, #6449ba 100%),
    linear-gradient(#b10042, #b10042);
}
</style>
